// TODO: Change to Avatar along with IconCircle
import { styled, Theme } from '@mui/material';
import Box, { BoxProps } from '@mui/material/Box';

type BadgeSeverity = 'grey' | 'info' | 'success' | 'warning' | 'error';

interface BadgeProps extends BoxProps {
    icon: React.JSX.Element;
    severity?: BadgeSeverity;
    size?: 'small' | 'medium';
}

const getBadgeColor = (theme: Theme, color: BadgeSeverity): { backgroundColor: string; color: string } => {
    switch (color) {
        case 'info':
            return {
                backgroundColor: theme.palette.info.selected,
                color: theme.palette.info.main,
            };
        case 'success':
            return {
                backgroundColor: theme.palette.success.selected,
                color: theme.palette.success.main,
            };
        case 'warning':
            return {
                backgroundColor: theme.palette.warning.selected,
                color: theme.palette.warning.main,
            };
        case 'error':
            return {
                backgroundColor: theme.palette.error.selected,
                color: theme.palette.error.main,
            };
        default:
        case 'grey':
            return {
                backgroundColor: theme.palette.neutral.twilight,
                color: theme.palette.neutral.contrastText,
            };
    }
};

const StyledBadge = styled(Box, { shouldForwardProp: (prop) => prop !== 'severity' })<{
    severity: BadgeSeverity;
    size: 'small' | 'medium';
}>(({ severity, size, theme }) => {
    const isSmall = size === 'small';
    return {
        ...getBadgeColor(theme, severity),
        ...theme.typography.flexAlignCenter,
        border: theme.constants.border,
        borderRadius: theme.constants.borderRadius,
        height: isSmall ? 32 : 40,
        justifyContent: 'center',
        width: isSmall ? 32 : 40,
        '& .MuiSvgIcon-root': {
            height: 24,
            width: 24,
        },
        flexShrink: 0,
    };
});

export const Badge: React.FC<BadgeProps> = ({ icon, severity = 'grey', size = 'medium', ...props }) => {
    return (
        <StyledBadge severity={severity} size={size} {...props}>
            {icon}
        </StyledBadge>
    );
};
